import {
  Box, InputAdornment, InputBase, Typography,
} from '@mui/material'
import { handleOnKeyDown } from 'src/utils/Form'
import { FieldPath, FieldValues, UseFormRegister } from 'react-hook-form'
import ScanCodeIcon from 'src/assets/images/other-images/ScanCode.svg'

interface ScanCodeInputProps<T extends FieldValues, K extends FieldPath<T>> {
  onSubmit: () => void
  register: UseFormRegister<T>;
  inputName: K;
  dataTestId: string;
  hasError?: boolean;
  errorMessage: string | undefined;
}

const ScanCodeInput = <T extends FieldValues, K extends FieldPath<T>>(
  scanCodeInput: ScanCodeInputProps<T, K>,
) => {
  const {
    register,
    onSubmit,
    inputName,
    dataTestId,
    hasError,
    errorMessage,
  } = scanCodeInput

  return (
    <Box sx={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      width: '100%',
      height: '4rem',
    }}
    >
      <Box sx={{ width: '62%' }}>
        <InputBase
          onKeyDown={(e) => handleOnKeyDown(e, '', onSubmit)}
          inputProps={{ ...register(inputName) }}
          id={inputName}
          data-testid={dataTestId}
          autoFocus
          endAdornment={(
            <InputAdornment position='end'>
              <img src={ScanCodeIcon} alt='scan code icon' />
            </InputAdornment>
            )}
          sx={{
            border: '1px solid #000000',
            backgroundColor: '#FFFFFF',
            borderRadius: '0.4rem',
            padding: '0.4rem',
            height: '2.6rem',
            width: '100%',
          }}
        />
        {
          hasError && (
            <Typography
              color='red'
              variant='caption'
            >
              {errorMessage}
            </Typography>
          )
        }
      </Box>
    </Box>
  )
}

export default ScanCodeInput
